// wrapper for value written to storage, recording the timestamp when written and ttl
interface StorageItem {
    ttl: number;            // TTL (in ms) of item. 0 if infinite
    timestamp: number;      // timestamp (in ms) when item last stored
    value: Object|string;   // item value
}

export class StorageEntry<T extends Object|string> {
    private readonly _key: string;
    private readonly _storage: Storage;
    // We need to do this because otherwise short of pulling in the
    // reflection API there's no way for our code to actually know what
    // type it is in methods that don't have a type param passed in.
    private _ttl: number;

    constructor(storage: Storage, key: string, ttl?: number) {
        this._key = key;
        this._storage = storage;
        this._ttl = ttl || 0;    // 0 means no expiry
    }

    get = (): T | null => {
        try {
            const storedString = this._storage.getItem(this._key);
            if (!storedString) {
                return null;
            }
            const item: StorageItem = JSON.parse(storedString);
            const expired = !item || item.ttl && (Date.now() - item.timestamp > item.ttl);
            if (!expired) {
                return item.value as T;
            }
        } catch { }

        // in both error and expiry case we want to remove the item
        this.remove();
        return null;
    }

    set = (val: T|string): void => {
        const item: StorageItem = {
            ttl: this._ttl,
            timestamp: Date.now(),
            value: val
        };

        this._storage.setItem(this._key, JSON.stringify(item));
    }

    remove = (): void => {
        this._storage.removeItem(this._key);
    }

}


// WEBPACK FOOTER //
// ./src/utils/storageEntry.ts